import { Flex } from "@chakra-ui/react";
import React from "react";

export const ObjectHeaderContainer: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <Flex
      h="64px"
      minH="64px"
      alignItems="center"
      backgroundColor="white"
      py={2}
      px={{ base: 4, lg: 8 }}
    >
      {children}
    </Flex>
  );
};
